export default __webpack_public_path__ + "static/cafe_36010-03d736d2c947cf0357ffd4c8f00f7a43.png";